export default (props = {}) => <svg viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg"{...props}>
<g id="Arrows / ArrowDown">
<path id="Vector" d="M18.3079 8.29289C18.695 7.90239 19.3226 7.90236 19.7097 8.29289C20.0968 8.68341 20.0968 9.3166 19.7097 9.7071L14.1026 15.364C12.9414 16.5355 11.0586 16.5355 9.89736 15.364L4.29031 9.7071C3.90322 9.31657 3.90325 8.68338 4.29031 8.29288C4.67737 7.90239 5.30498 7.90236 5.69207 8.29288L11.2991 13.9497C11.6862 14.3403 12.3138 14.3403 12.7009 13.9497L18.3079 8.29289Z" />
</g>
</svg>
